<template>
  <div class="box">
    <div class="inner">
      <img
        :src="imageUrl"
        :onerror="require('@/assets/template/no_image.svg')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageDetailView",
  componentName: "ImageDetailView",
  data() {
    return {
      imageUrl: this.$route.params.imageUrl
        .replace(/\[slash\]/g, "/")
        .replace(/\[question\]/g, "?"),
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
html,
body {
  width: 100vw;
  height: 100vh;
}
.box {
  background: #000;
  display: table;
  height: 100vh;
  text-align: center;
  width: 100vw;
}
.inner {
  display: table-cell;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/ImageDetailView.vue